<template>
  <div class="case">
    <banner img="../assets/img/bgtop.jpg" title="园区" />
    <div class="case-section" v-loading="loading">
      <div class="case-section-content">
        <div class="case-section-content-list" v-for="(cas,index) in caseList" :key="index">
          <img v-lazy="cas.Img" />
          <div class="content-list-abstract" :class="{'abstract-active' : index%2!=1}">
            <p class="abstract-title">{{cas.Title}}</p>
            <p class="abstract-content">{{cas.Content}}</p>
            <div class="more">
              <router-link
                class="text-decoration"
              >
                <span>more</span>
                <img src="../assets/img/sanjiao.png" />
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vfooter />
  </div>
</template>
<script>
import Banner from "../components/Banner";
import vfooter from "../components/footer";
export default {
  components: {
    Banner,
    vfooter
  },
  data() {
    return {
      loading: false,
      caseList: [
        {
          Img: "/img/新田分公司.png",
          Title: "湖南省永州市新田县龙泉镇工业南园电子商务物流园内",
        },
        {
          Img: "/img/芜湖分公司.png",
          Title: "安徽省芜湖市繁昌县繁阳大道繁昌数字经济产业园",
        },
        {
          Img: "/img/新余分公司.png",
          Title: "江西省新余市渝水区新兴工业产业园服务中心创新",
        },
        {
          Img: "/img/吉安分公司.png",
          Title: "江西省吉安市永丰县恩江镇永丰大道新世纪花园",
        },
        {
          Img: "/img/烟台分公司.png",
          Title: "福建省厦门市同安区汀溪镇汀溪一里",
        }
      ]
    };
  }
};
</script>

 <style lang="scss" scoped>
.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: #14679f;

  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid pink;

        img {
          width: 612px;
          height: 314px;
        }
        .content-list-abstract {
          width: 290px;
          height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #e13834;
          }
          .abstract-content {
            height: 150px;
            color: #484848;
            font-size: 15px;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            //border: 1px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
</style>